import { ComponentRegisterOrder } from "src/Components/ClaimPointFromEcom";

export const PageRegisterOrder = () => {
    return <ComponentRegisterOrder />;
};
